/**
 * FEATURED PROJECTS MANAGER
 * Returns the current featured project
 */

import currentProject from './current';
import residentialProject from './residential';
import commercialProject from './commercial';
import maintenanceProject from './maintenance';

const getCurrentSeasonProject = () => {
  // Default to current project
  return currentProject;
};

// Export all projects for debugging/testing
export const allProjects = {
  current: currentProject,
  residential: residentialProject,
  commercial: commercialProject,
  maintenance: maintenanceProject,
};

// Optional: Function to get a specific project (useful for testing)
export const getProjectByType = (type) => {
  return allProjects[type] || currentProject;
};

console.log("📅 Featured project loaded");

export default getCurrentSeasonProject;